import React from "react";
import { useTranslation } from "react-i18next";
import injectSheet from "react-jss";

import { Button, Spacing, B } from "folksam-ui";
// import EditIcon from "components/EditIcon/EditIcon";

const styles = ({ theme }) => ({
  root: {
    color: theme.colors.primary2,
    backgroundColor: theme.colors.white,
    padding: `${theme.padding.sm} ${theme.padding.md}`,
    marginBottom: theme.margin.sm,
    fontFamily: theme.fonts.serif,
    fontSize: theme.textSizes.copy,
    fontWeight: theme.fontWeights.semibold,
    borderBottom: `2px solid #D3C3BC`
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center"
  },
  button: {
    "&:hover $icon": {
      fill: theme.colors.linkHover
    }
  },
  icon: {
    lineHeight: 0,
    fill: theme.colors.link,
    marginLeft: theme.padding["1"]
  },
  heading: {
    flexGrow: 1
  }
});

const ItemListItemHeader = ({
  classes,
  heading,
  showEdit,
  onExpandClick,
  onRemoveClick,
  readOnly,
  id,
  disabled
}) => {
  const { t } = useTranslation();
  return (
    <div className={classes.root} role="tab">
      <div className={classes.inner}>
        <div className={classes.heading}>{heading}</div>
        {showEdit ? (
          <Spacing left={"3"}>
            <Button
              style={{
                fontSize: "14px",
                color: "#f35b1c"
              }}
              small
              asLink
              type="button"
              onClick={onExpandClick}
              readOnly={readOnly}
              disabled={disabled}
            >
              <B>{t("list.item.change.label")}</B>
            </Button>
          </Spacing>
        ) : null}
        <Spacing left={"3"}>
          <Button
            style={{
              fontSize: "14px",
              color: "#f35b1c"
            }}
            small
            asLink
            type="button"
            onClick={onRemoveClick}
            readOnly={readOnly}
            disabled={disabled}
          >
            <B>{t("list.item.remove.label")}</B>
          </Button>
        </Spacing>
      </div>
    </div>
  );
};

ItemListItemHeader.propTypes = {};

export default injectSheet(styles)(ItemListItemHeader);
